<script setup>
import { useI18n } from 'vue-i18n'

import { SIDEBAR_EMPTY_STATE_TEST_ID } from '@/components/home-page/jest-helpers'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'HomepageSidebarFilterEmptyState'
})

const { t } = useI18n()
</script>

<template>
  <div
    :data-auto-testid="SIDEBAR_EMPTY_STATE_TEST_ID"
    :data-testid="SIDEBAR_EMPTY_STATE_TEST_ID"
    class="hsfe-EmptyState"
  >
    <slot name="hero">
      <AppIcon height="64" icon-name="no-groups-hero" width="87" />
    </slot>

    <slot>{{ t('common.no_results') }}</slot>
  </div>
</template>

<style lang="scss" scoped>
.hsfe-EmptyState {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 12px;
  text-align: center;
  font-style: normal;
  font-weight: fw('regular');
  font-size: $fs-14;
  line-height: 20px;
  color: $dark-3;
  font-family: $system-ui;
}
</style>
